import React, { Component } from 'react';
import { throttle } from 'lodash';

import { biLogSafe } from '../../../../universal/biService';
import { createMainController } from '../../../services/createMainController';
import NamesListV3Desktop from '../../../components/NamesListPageV3/Desktop/NamesListV3Desktop';
import NamesListV3Mobile from '../../../components/NamesListPageV3/Mobile/NamesListV3Mobile';
import LottieLoaderServiceBng from '../../../services/LottieLoaderServiceBng';

class NameListControllerV3 extends Component {
  constructor(props) {
    super(props);
    const { selectors } = props;
    this.state = {
      namesList: selectors.getNameslist(),
      industry: selectors.getIndustry(),
      loading: false,
      referralInfo: selectors.getReferralInfo(),
      scrollTop: 0
    };
    this.NavigateToMarketingLP = false;
  }

  componentDidMount() {
    const { referralInfo } = this.state;
    biLogSafe(biLogger => {
      biLogger('businessNameGeneratorPageOpen', { origin: referralInfo, pageName: 'Names List' });
    });
  }
  handleNameLineClicked = index => {
    const { selectors, setSelectedName } = this.props;
    const { referralInfo } = this.state;
    const industry = selectors.getIndustry();
    const businessIdea = selectors.getBusinessIdea();
    const selectedIndex = selectors.getSelectedIndex();
    let currentSelected = -1;
    if (selectedIndex !== index) {
      currentSelected = index;
    }
    biLogSafe(biLogger => {
      biLogger('businessNameGeneratorButtonClick', {
        origin: referralInfo,
        pageName: 'Names List',
        buttonName: 'Name Clicked',
        additionalInfo: JSON.stringify({ businessName: businessIdea, industry: industry.industryText })
      });
    });
    setSelectedName(currentSelected);
  };

  handleBusinessIdeaChange = value => {
    const { setBusinessIdea } = this.props;
    setBusinessIdea(value);
  };

  handleSearchNames = () => {
    const { selectors, searchNamesAndIndustry } = this.props;
    const { referralInfo } = this.state;
    const tags = selectors.getSelectedTags();
    const industry = selectors.getIndustry();
    const businessIdea = selectors.getBusinessIdea();
    this.setState(
      () => {
        return {
          loading: true
        };
      },
      () => {
        searchNamesAndIndustry(businessIdea, tags, industry.industry, industry.industryText);
      }
    );
    biLogSafe(biLogger => {
      biLogger('businessNameGeneratorButtonClick', {
        origin: referralInfo,
        pageName: 'Names List',
        buttonName: 'New Search',
        additionalInfo: JSON.stringify({ businessName: businessIdea, industry: industry.industryText })
      });
    });
  };

  handleIndustryChange = (id, text, isCustom) => {
    const { setIndustry } = this.props;
    setIndustry(id, text, isCustom);
  };

  handleScroll = element => {
    const scrollTop = element.target.scrollTop;
    this.updateScrollTop(scrollTop);
  };

  updateScrollTop = throttle(scrollTop => {
    this.setState({ scrollTop });
  }, 100);

  componentWillReceiveProps(nextProps) {
    const {
      state: { namesList: currentList = [] }
    } = this.props;
    const {
      state: { namesList: newList = [], industry }
    } = nextProps;

    if (currentList !== newList) {
      this.setState(() => {
        return {
          namesList: newList,
          industry,
          loading: false
        };
      });
    }
  }

  handleLikeClicked = (e, nameIndex) => {
    e.stopPropagation();
    const { likedName } = this.props;
    likedName(nameIndex);
  };

  fetchIndustries = term => {
    const {
      services: { industryService }
    } = this.props;
    return industryService.getIndustrySuggestions(term);
  };

  handleDomainClicked = (e, domainName) => {
    e.stopPropagation();
    const { screenType } = this.props;
    const { goToDomainPageV3 } = this.props;
    goToDomainPageV3(domainName, screenType, this.NavigateToMarketingLP);
  };

  render() {
    const { t, selectors, screenType, version, openVersion } = this.props;
    const businessIdea = selectors.getBusinessIdea();
    const industry = selectors.getIndustry();
    const selectedIndex = selectors.getSelectedIndex();
    const { namesList, loading, referralInfo, scrollTop } = this.state;
    const NameListPageComponent = screenType === 'desktop' ? NamesListV3Desktop : NamesListV3Mobile;
    return (
      <NameListPageComponent
        version={version}
        industriesFetcher={this.fetchIndustries}
        loading={loading || (namesList && namesList.length === 0)}
        screenType={screenType}
        onSearchNames={this.handleSearchNames}
        onBusinessIdeaChange={this.handleBusinessIdeaChange}
        onIndustryChange={this.handleIndustryChange}
        businessIdea={businessIdea}
        industry={industry}
        t={t}
        currentIndexIsOpen={selectedIndex}
        onNameLineClicked={this.handleNameLineClicked}
        namesList={namesList}
        onDisableExpand={this.handleDisableExpand}
        onLikeClicked={this.handleLikeClicked}
        openVersion={openVersion}
        onDomainClicked={this.handleDomainClicked}
        referralInfo={referralInfo}
        onScroll={this.handleScroll}
        scrollTop={scrollTop}
      />
    );
  }
}

let loadingTime = 5000;
if (process.env.NODE_ENV === 'development') {
  loadingTime = 0;
}

export default createMainController(NameListControllerV3, {
  shouldFetch: true,
  loader: LottieLoaderServiceBng,
  fetchData: {
    stateName: 'namesList',
    baseState: ['businessIdea', 'industry', 'tags']
  },
  minLoaderTime: loadingTime
});
